import { render, staticRenderFns } from "./signatureTemplate.vue?vue&type=template&id=1c79cea3&scoped=true"
import script from "./signatureTemplate.vue?vue&type=script&lang=js"
export * from "./signatureTemplate.vue?vue&type=script&lang=js"
import style0 from "./signatureTemplate.vue?vue&type=style&index=0&id=1c79cea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79cea3",
  null
  
)

export default component.exports